var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlueICon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6101 5.38925C24.13 4.86932 24.13 4.00278 23.6101 3.50951L20.4905 0.389946C19.9972 -0.129982 19.1307 -0.129982 18.6107 0.389946L16.1578 2.82961L21.1571 7.82891M0 19.0007V24H4.99931L19.7439 9.24205L14.7446 4.24274L0 19.0007Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlueICon);
export default __webpack_public_path__ + "static/media/editBlueICon.91e3f833be2d8ee91137312d2d41a252.svg";
export { ForwardRef as ReactComponent };